import { loadFont } from '@lib/loadFont';
import { cdn } from '@css/constants';

export const AvertaPeFont = {
  family: 'AvertaPE',
  style: 'normal',
  url: `${cdn}/fonts/averta`,
  fallback: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
  weights: {
    '300': {
      eot: '377A84_1_0.eot',
      eot_ie: '377A84_1_0.ie.eot',
      woff2: '377A84_1_0.woff2',
      woff: '377A84_1_0.woff',
      ttf: '377A84_1_0.ttf'
    },
    '400': {
      eot: '377A84_2_0.eot',
      eot_ie: '377A84_2_0.ie.eot',
      woff2: '377A84_2_0.woff2',
      woff: '377A84_2_0.woff',
      ttf: '377A84_2_0.ttf'
    },
    '500': {
      eot: '3780E8_4_0.eot',
      eot_ie: '3780E8_4_0.ie.eot',
      woff2: '3780E8_4_0.woff2',
      woff: '3780E8_4_0.woff',
      ttf: '3780E8_4_0.ttf'
    },
    '600': {
      eot: 'font.eot',
      woff2: 'font.woff2',
      woff: 'font.woff',
      ttf: 'font.ttf'
    },
    '700': {
      eot: 'font.eot',
      woff2: 'font.woff2',
      woff: 'font.woff',
      ttf: 'font.ttf'
    }
  }
}

export const AvertaPeNormal300 = loadFont(AvertaPeFont, 300);
export const AvertaPeNormal400 = loadFont(AvertaPeFont, 400);
export const AvertaPeNormal500 = loadFont(AvertaPeFont, 500);
export const AvertaPeNormal600 = loadFont(AvertaPeFont, 600);
export const AvertaPeNormal700 = loadFont(AvertaPeFont, 700);

export function FontNormal(weight: number) {
  switch(weight) {
    case 100:
    case 200:
    case 300: return AvertaPeNormal300;
    case 400: return AvertaPeNormal400;
    case 500: return AvertaPeNormal500;
    case 600: return AvertaPeNormal600;
    case 700:
    case 800: return AvertaPeNormal700;
  }
}
